import {WidgetModelInterface} from "./Widget";

export const logoWidget: WidgetModelInterface = {
    config: {
        type: 'Logo',
        displayName: 'Logo'
    },
    isSelected: false,
    data: {
        src:''
    }

};

export const titleWidget: WidgetModelInterface = {
    config: {
        type: 'Title',
        displayName: 'Title'
    },
    isSelected: false,
    data: {
        title:'',
        subTitle:'',
    }

};

export const menuDataWidget: WidgetModelInterface = {
    config: {
        type: 'Navigation',
        displayName: 'Navigation'
    },
    isSelected: false,
    data: {}
};

export const postDataWidget: WidgetModelInterface = {
    config: {
        type: 'Post',
        displayName: 'Post'
    },
    isSelected: false,
    data: {
        size: 'Small',
        isBgGray: false,
    }
};

export const postLargeDataWidget = Object.assign({}, postDataWidget, {data: {...postDataWidget.data, 'size': 'Large'}});
